module.exports = "/images/vendor/flag-icon-css/flags/4x3/uy.svg?79b02850081e27b3ba209e6ae60ad50f";